import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SuccessIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Price = ({
  currencyCode,
  simplifyCurrency,
  value,
  children
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "baseline",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "0",
      typography: "heading-600",
      children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
        currencyCode: currencyCode,
        simplifyCurrency: simplifyCurrency,
        value: value
      })
    }), children ? /*#__PURE__*/_jsx(Text, {
      as: "small",
      children: children
    }) : null]
  });
};
export function PricingPlan({
  currency,
  pricing
}) {
  const {
    name,
    planType,
    amount,
    contactUsDetails,
    contactUsPlanType,
    contactUsUrl,
    commitmentAmount,
    extraCharges,
    features,
    meterUnit,
    tagline
  } = pricing;
  const [showCommitmentPricing, setShowCommitmentPricing] = useState(true);
  const renderedPrice = useMemo(() => {
    if (planType === 'CONTACT_US' && !contactUsPlanType) {
      return null;
    }
    let value;
    if (planType === 'FREE') {
      value = 0;
    } else if (planType === 'MONTHLY' && showCommitmentPricing && commitmentAmount) {
      value = commitmentAmount / 12;
    } else {
      value = amount;
    }
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "baseline",
      gap: "100",
      children: [planType === 'CONTACT_US' && /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.pricingCard.plan.startsAt"
        })
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `detailsPage.pricingCard.plan.pricing.${planType === 'CONTACT_US' ? contactUsPlanType : planType}_jsx`,
        options: {
          currencyCode: currency,
          simplifyCurrency: true,
          value,
          meterUnit
        },
        elements: {
          Price,
          Text
        }
      })]
    });
  }, [amount, contactUsPlanType, commitmentAmount, currency, meterUnit, planType, showCommitmentPricing]);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    inlineSize: "50%",
    children: [/*#__PURE__*/_jsxs(CardSection, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          children: name
        }), planType === 'MONTHLY' && commitmentAmount ? /*#__PURE__*/_jsxs(ToggleGroup, {
          name: "commitment-pricing-toggle",
          children: [/*#__PURE__*/_jsx(RadioInput, {
            defaultChecked: true,
            inline: true,
            size: "small",
            onChange: () => setShowCommitmentPricing(true),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.pricingCard.plan.commitmentPricingToggleLabels.yearly"
            })
          }), /*#__PURE__*/_jsx(RadioInput, {
            inline: true,
            size: "small",
            onChange: () => setShowCommitmentPricing(false),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.pricingCard.plan.commitmentPricingToggleLabels.monthly"
            })
          })]
        }) : null]
      }), renderedPrice, /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: extraCharges
      }), /*#__PURE__*/_jsx(Text, {
        children: tagline
      }), features ? /*#__PURE__*/_jsx(List, {
        children: features.split(/\r?\n/g).filter(feature => feature.trim()).map((feature, index) => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(MediaObject, {
            marginBlockEnd: "200",
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(IconHolder, {
              icon: SuccessIcon,
              color: "fill-positive-default"
            }),
            children: /*#__PURE__*/_jsx(Text, {
              typography: "detail-200",
              children: feature
            })
          })
        }, `pricing-feature-${index}`))
      }) : null, /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: contactUsDetails
      })]
    }), planType === 'CONTACT_US' && contactUsUrl ? /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(Button, {
        external: true,
        href: contactUsUrl,
        size: "sm",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.pricingCard.plan.contactUs"
        })
      })
    }) : null]
  });
}